module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5s Gold.72478d48.png";